module.exports = __webpack_public_path__ + "img/a2-s23.1eaafd2f.jpg";